module.exports = __webpack_public_path__ + "img/adventure_thumbnail.71bbc47a.jpg";